import { AddUserPage } from '@components'
import { createFileRoute } from '@tanstack/react-router'
import { parseAsTeamId } from '@util'
import { useQueryState } from 'nuqs'
import type { ReactElement } from 'react'

function Add(): ReactElement {
  const [teamId] = useQueryState('teamId', parseAsTeamId)
  return <AddUserPage teamId={teamId ?? undefined} />
}

export const Route = createFileRoute('/user_/add/')({
  component: Add,
})
